<script setup>
const props = defineProps({
  title: String,
  subtitle: String,
  subtitle2: Object,
});
</script>

<template>
  <div :class="$style['section-header']">
    <h2 v-if="props.title" :class="$style['section-header__title']">
      {{ props.title }}
    </h2>
    <div v-if="props.subtitle" :class="$style.subtitle">
      {{ props.subtitle }}
      <div v-if="props.subtitle2">
        {{ props.subtitle2.title }}
        <a
          v-if="props.subtitle2.href && props.subtitle2.link"
          target="_blank"
          :href="props.subtitle2.href"
          >{{ props.subtitle2.link }}</a
        >
      </div>
    </div>
  </div>
</template>

<style module lang="less">
.section-header {
  margin-bottom: 40px;
  text-align: center;
}

.section-header__title {
  color: var(--neutral-black, #000);
  font-family: @regular-font;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
}

.subtitle {
  color: var(--neutral-black, #000);
  font-family: @regular-font;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 24px;
}
</style>
